const LEGACY_STORAGE_PREFIX = 'dashboards:customer-service:last-reports'

function removeLegacyReports(): void {
    try {
        const legacy = Object.keys(localStorage).filter(key =>
            key.startsWith(LEGACY_STORAGE_PREFIX),
        )
        for (const key of legacy) localStorage.removeItem(key)
    } catch {
        return
    }
}

removeLegacyReports()
